import React from 'react';
import Link from 'next/link';
import AnimatedGradientButton from '../shared/AnimatedGradientButton';
import NavBarClient from './NavBarClient';

const NavBar = (props: {
  hideIcons?: boolean;
  isStatic?: boolean;
  isTransparent?: boolean;
}) => {
  // Static navigation links that can be server-side rendered
  const navigationLinks = {
    leftColumn: (
      <>
        <Link
          href="/hiv-test"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Our Product
        </Link>
        <Link
          href="/our-story"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Our Story
        </Link>
        <Link
          href="/our-network"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Our Network
        </Link>
        <Link
          href="/#faq"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          FAQ
        </Link>
        <Link
          href="/blog"
          className="flex items-center gap-2 px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Blog
        </Link>
      </>
    ),
    rightColumn: (
      <>
        <Link
          href="/sti-info"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          STI Info
        </Link>
        <Link
          href="/resources"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Sexual Health Resources
        </Link>
        <Link
          href="/interpreting-results"
          className="px-1 font-['Karla'] text-[18px] leading-[42px] font-normal hover:underline md:text-[20px]"
        >
          Interpreting Your Results
        </Link>
      </>
    ),
  };

  // Static action buttons that can be server-side rendered
  const actionButtons = (
    <>
      <AnimatedGradientButton
        flatHover={true}
        as="link"
        text="Purchase a Kit"
        href="/hiv-test"
        className="min-w-[180px] max-md:hidden"
      />
      <AnimatedGradientButton
        flatHover={true}
        as="link"
        text="Complete My Test"
        href="/sign-in"
        theme="purple"
        className="min-w-[180px] max-md:hidden"
      />
    </>
  );

  return (
    <NavBarClient
      {...props}
      navigationLinks={navigationLinks}
      actionButtons={actionButtons}
    />
  );
};

export default NavBar;
